module.exports = __webpack_public_path__ + "img/News.42cb5aeb.png";